(() => {
  const attemptedKey = 'kiddyview-localization-attempt';

  function storageHasAttempted(signature) {
    try {
      return sessionStorage.getItem(attemptedKey) === signature;
    } catch (_error) {
      return false;
    }
  }

  function markStorageAttempted(signature) {
    try {
      sessionStorage.setItem(attemptedKey, signature);
    } catch (_error) {
      // Safari private browsing can block storage; localization can still continue.
    }
  }

  function clearStorageAttempt() {
    try {
      sessionStorage.removeItem(attemptedKey);
    } catch (_error) {
      // Safari private browsing can block storage; localization can still continue.
    }
  }

  function addInput(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.append(input);
  }

  function updateLocalization({ country, language, root }) {
    const form = document.createElement('form');
    form.hidden = true;
    form.method = 'post';
    form.action = `${root}localization`;

    addInput(form, '_method', 'PUT');
    addInput(form, 'country_code', country);
    addInput(form, 'language_code', language);

    document.body.append(form);
    form.submit();
  }

  async function initializeLocalization() {
    const logic = globalThis.KiddyViewLocalizationLogic;
    const shopify = globalThis.Shopify;
    if (!logic || !shopify) return;
    if (logic.hasExplicitLocalePrefix(location.pathname)) {
      clearStorageAttempt();
      return;
    }

    const root = shopify.routes?.root || '/';
    const params = new URLSearchParams({
      'country[enabled]': 'true',
      'country[exclude]': shopify.country || '',
      'language[enabled]': 'true',
      'language[exclude]': shopify.language || ''
    });

    try {
      const response = await fetch(`${root}browsing_context_suggestions.json?${params}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;

      const suggestion = await response.json();
      const detectedCountry = suggestion?.detected_values?.country?.handle;
      if (!logic.shouldAutoLocalize({
        pathname: location.pathname,
        currentCountry: shopify.country,
        currentLanguage: shopify.language,
        detectedCountry
      })) return;

      const language = logic.localeForCountry(detectedCountry);
      const attemptSignature = `${shopify.country || ''}:${shopify.language || ''}->${detectedCountry}:${language}`;
      if (storageHasAttempted(attemptSignature)) return;

      markStorageAttempted(attemptSignature);
      updateLocalization({ country: detectedCountry, language, root });
    } catch (_error) {
      // Keep the current storefront usable if Shopify's suggestion endpoint is unavailable.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLocalization, { once: true });
  } else {
    initializeLocalization();
  }
})();
